export default __webpack_public_path__ + "static/media/icon-check-purple.4dfe0f9f.svg";